const QrCode = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            stroke="currentColor"
            stroke-linecap="square"
            stroke-width="1.5"
            d="M13.748 13.75v2.5h2.5m1.5-2.5h2.5m0 4h-2.5v2.5m-4-.5v.5m-10-16.5h6.5v6.5h-6.5v-6.5Zm10 0h6.5v6.5h-6.5v-6.5Zm-10 10h6.5v6.5h-6.5v-6.5Z"
        />
    </svg>
);

export default QrCode;
